<template>
  <!--translate-->
  <div>
    <div v-if="item.accessRole">
      {{ $t(`accessRoles.roles.${item.accessRole}`) }}
      <span v-if="item.role == 'Owner' || item.role == 'MultiUser'" class="grey--text">
        ({{ item.role == "Owner" ? $t("users.roleOwner") : $t("users.roleMultiuser") }})
      </span>
    </div>
    <template v-else>
    <div v-if="item.role == 'User'">{{ $t("users.roleUser") }}</div>
    <div v-if="item.role == 'Owner'">{{ $t("users.roleOwner") }}</div>
    <div v-if="item.role == 'MultiUser'">{{ $t("users.roleMultiuser") }}</div>
    </template>
  </div>
</template>
<script>
export default {
  props: ["item"],
  methods: {},
};
</script>
